import React from "react";
import { Form } from "react-bootstrap";
import InfoText from "./InfoText";

const LabelWithLink = ({ labelText, linkText, link, className, labelMandatory, infoText = null }) => {
  const getLabel = () => {
    if (!linkText || !link) {
      return labelText;
    }

    const labelSplit = labelText.split(new RegExp(`(${escapeRegExp(linkText)})`, "g"));
    const completeLabel = labelSplit.map((text, index) => {
      if (text === linkText) {
        return (
          <a key={index} href={link} className="rdb_label_link" target="_blank" rel="noreferrer">
            {text}
          </a>
        );
      }

      return <React.Fragment key={index}>{text}</React.Fragment>;
    });

    return completeLabel;
  };

  const escapeRegExp = string => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  return (
    <Form.Label className={className}>
      {labelMandatory && <span className="span_mandatory">{labelMandatory}</span>}
      {getLabel()}
      {infoText?.link && (
        <InfoText className={infoText.className} tooltip={infoText.link.text} link={infoText.link.url} />
      )}
    </Form.Label>
  );
};

export default LabelWithLink;
